export type SubaccountRoutes = ReadonlyArray<string>;

export const subaccountRoutes: SubaccountRoutes = ["/account/profile"];

export default subaccountRoutes;
